<template>
    <div>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Manual Moved item"  ok-title="Confirm" ok-only
                     v-model="moveModal"
                     :ok-disabled="invalid"
                     @ok="moveItemReason">
                <h5>Please enter reasons for moving manually:</h5>
                <b-form>
                    <validation-provider
                            name="Reason"
                            :rules="{  }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                label="Reason"
                                label-for="secure-bag-metal">
                            <b-form-input :type="'text'" v-model="moveReason"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-form>
            </b-modal>
        </validation-observer>
        <b-row class="font-weight-bold h6 border-bottom pb-1 mb-1">
            <b-col class=" mb-0">ID</b-col>
            <b-col class=" mb-0" cols="4">Type</b-col>
            <b-col class=" mb-0" cols="3">Metal</b-col>
            <b-col class="mb-0 text-right mr-3">Weight</b-col>
        </b-row>
        <div class="batch-scroll pr-3">
            <div style="min-height:10px;" :id="grouping + '?'">
                <div v-for="(bag, index1) in localStatuses">
                    <b-row :id="`click-control-${bag.id}`"
                           :class="[ `depth-0`, bag.indexedType !== 'bag' ? 'pointer' : '', !canDisplay(bag) ? 'd-none' : '' ]">
                        <b-col  @contextmenu.prevent="rightClickHandler($event, bag)">
                            <a :href="bag.container_type == 'bag' ? `appraisals/bagging/${bag.order_id}` : `kit/view/${bag.order_id}`"
                               :class="bag.depth !== 0 ? 'text-dark' : '' ">
                                {{ bag.component_id }}</a>
                        </b-col>

                        <b-col cols="4" @contextmenu.prevent="rightClickHandler($event, bag)">{{ bag.type }}</b-col>

                        <b-col cols="3" @contextmenu.prevent="rightClickHandler($event, bag)">{{ bag.metal | titleCase }}<i v-if="bag.contains_melee" class="fa-xs ml-1 text-info fa-regular fa-gem "></i></b-col>

                        <b-col class="text-right" @contextmenu.prevent="rightClickHandler($event, bag)">{{ bag.weight }}</b-col>
                        <!-- </b-row> -->

                        <b-popover ref="popover" :id="`click-control-${bag.id}`" :target="`click-control-${bag.id}`">
                            <div class="">
                                <b-list-group>
                                    <b-list-group-item href="#" @click="moveItem('binned', bag, index1)">
                                        <i class="mr-1 fa-fw fa-solid fa-inbox fa-xs--"></i>
                                        <span class="font-weight-bold">Move to Binned</span> (melt)</b-list-group-item>

                                    <b-list-group-item href="#" @click="moveItem('pulled', bag, index1)">
                                        <i class="mr-1 fa-fw fa-solid fa-tags text-success fa-xs--"></i>
                                        <span class="font-weight-bold">Move to Held</span></b-list-group-item>

                                    <b-list-group-item href="#" @click="moveItem('zerovalue', bag, index1)">
                                        <i class="mr-1 fa-fw fa-solid fa-magnet fa-xs--" style="color: #c40285;"></i>
                                        <span class="font-weight-bold">Move to Zero-Value</span></b-list-group-item>

                                    <b-list-group-item href="#" @click="moveItem('exception', bag, index1)">
                                        <i class="mr-1 fa-fw fa-solid fa-question-circle text-danger fa-xs--"></i>
                                        <span class="font-weight-bold">Move to Exception</span></b-list-group-item>
                                </b-list-group>
                            </div>
                        </b-popover>
                    </b-row>
                    <!-- ****************************************** CHILDREN (ITEMS) OF BAGS *******************************************************-->
                    <div :id="grouping + '?parent_item|' + bag.id" :style="bag.child_items.length ? 'min-height:10px;' : ''">
                        <div v-for="(item, index2) in bag.child_items">
                            <b-row :id="`click-control-${item.id}`"
                                   :class="[ `depth-1`, item.indexedType !== 'bag' ? 'pointer' : '', !canDisplay(item) ? 'd-none' : '' ]">
                                <b-col  @contextmenu.prevent="rightClickHandler($event, item)">
                                    <a :href="`kit/view/${item.order_id}`"
                                       :class="'text-dark'">
                                        {{ item.component_id }}</a>
                                </b-col>

                                <b-col cols="4" @contextmenu.prevent="rightClickHandler($event, item)">{{ item.type }}</b-col>

                                <b-col cols="3" @contextmenu.prevent="rightClickHandler($event, item)">{{ item.metal | titleCase }}<i v-if="bag.contains_melee" class="fa-xs ml-1 text-info fa-regular fa-gem"></i></b-col>

                                <b-col class="text-right" @contextmenu.prevent="rightClickHandler($event, item)">{{ item.weight }}</b-col>
                                <!-- </b-row> -->

                                <b-popover ref="popover" :id="`click-control--${item.id}`" :target="`click-control-${item.id}`">
                                    <div class="">
                                        <b-list-group>
                                            <b-list-group-item href="#" @click="moveItem('binned', item, bag, index1, index2)">
                                                <i class="mr-1 fa-fw fa-solid fa-inbox fa-xs--"></i>
                                                <span class="font-weight-bold">Move to Binned</span> (melt)</b-list-group-item>

                                            <b-list-group-item href="#" @click="moveItem('pulled', item, bag, index1, index2)">
                                                <i class="mr-1 fa-fw fa-solid fa-tags text-success fa-xs--"></i>
                                                <span class="font-weight-bold">Move to Held</span></b-list-group-item>

                                            <b-list-group-item href="#" @click="moveItem('zerovalue', item, bag, index1, index2)">
                                                <i class="mr-1 fa-fw fa-solid fa-magnet fa-xs--" style="color: #c40285;"></i>
                                                <span class="font-weight-bold">Move to Zero-Value</span></b-list-group-item>

                                            <b-list-group-item href="#" @click="moveItem('exception', item, bag, index1, index2)">
                                                <i class="mr-1 fa-fw fa-solid fa-question-circle text-danger fa-xs--"></i>
                                                <span class="font-weight-bold">Move to Exception</span></b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </b-popover>
                            </b-row>
                            <!-- ****************************************** CHILDREN (COMPONENTS) OF INVENTORY *******************************************************-->
                            <div :id="grouping + '?parent_item|' + bag.id + '|' + item.id"  :style="item.child_items.length ? 'min-height:10px;' : ''">
                                <b-row :id="`click-control-${comp.id}`" v-for="(comp, index3) in item.child_items"
                                       :class="[ `depth-2`, comp.indexedType !== 'bag' ? 'pointer' : '', !canDisplay(comp) ? 'd-none' : '' ]">
                                    <b-col  @contextmenu.prevent="rightClickHandler($event, comp)">
                                        <a :href="`kit/view/${item.order_id}`"
                                           :class="'text-dark'">
                                            {{ comp.component_id }}</a>
                                    </b-col>

                                    <b-col cols="4" @contextmenu.prevent="rightClickHandler($event, comp)">{{ comp.type }}</b-col>

                                    <b-col cols="3" @contextmenu.prevent="rightClickHandler($event, comp)">{{ comp.metal | titleCase }}<i v-if="comp.contains_melee" class="fa-xs ml-1 text-info fa-regular fa-gem "></i></b-col>

                                    <b-col class="text-right" @contextmenu.prevent="rightClickHandler($event, comp)">{{ comp.weight }}</b-col>
                                    <!-- </b-row> -->

                                    <b-popover ref="popover" :id="`click-control-${comp.id}`" :target="`click-control-${comp.id}`">
                                        <div class="">
                                            <b-list-group>
                                                <b-list-group-item href="#" @click="moveItem('binned', comp, item, index1, index2, index3)">
                                                    <i class="mr-1 fa-fw fa-solid fa-inbox fa-xs--"></i>
                                                    <span class="font-weight-bold">Move to Binned</span> (melt)</b-list-group-item>

                                                <b-list-group-item href="#" @click="moveItem('pulled', comp, item, index1, index2, index3)">
                                                    <i class="mr-1 fa-fw fa-solid fa-tags text-success fa-xs--"></i>
                                                    <span class="font-weight-bold">Move to Held</span></b-list-group-item>

                                                <b-list-group-item href="#" @click="moveItem('zerovalue', comp, item, index1, index2, index3)">
                                                    <i class="mr-1 fa-fw fa-solid fa-magnet fa-xs--" style="color: #c40285;"></i>
                                                    <span class="font-weight-bold">Move to Zero-Value</span></b-list-group-item>

                                                <b-list-group-item href="#" @click="moveItem('exception', comp, item, index1, index2, index3)">
                                                    <i class="mr-1 fa-fw fa-solid fa-question-circle text-danger fa-xs--"></i>
                                                    <span class="font-weight-bold">Move to Exception</span></b-list-group-item>
                                            </b-list-group>
                                        </div>
                                    </b-popover>
                                </b-row>
                            </div>
                            <!-- ******************** END OF COMPONENTS ****************** -->
                        </div>
                    </div>
                    <!-- ******************** END OF Invnetory ****************** -->
                </div>
            </div>
            <!-- ******************** END OF Bags ****************** -->
        </div>

    </div>
</template>



<script>
    import _ from 'lodash';
    export default {
        name: 'batch-order-table',
        components: {
        },
        props: ['items', 'path', 'orderItem', 'statuses', 'orderStatues', 'seekAndRemove', 'replace', 'status','seekItemsCallback', 'grouping', 'loading', 'search', 'lastMoveAttempt', 'lastMoveAttemptSet'],
        data() {
            return {
                localStatuses: [],
                cacheLocal: [],
                movedItem: null,
                moveReason: '',
                moveModal: false,
            };
        },
        created() {
            this.doUpdate();
            window.addEventListener('click', (event) => {
                this.$root.$emit('bv::hide::popover');
            });
        },
        methods: {
            moveItemReason() {
                this.$http.post('/batch/updateItem/' + this.movedItem, {'reason': this.moveReason});
            },
            startReason(id) {
                this.movedItem = id;
                this.moveReason = '';
                this.moveModal = true;
            },
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? valid : null;
            },
            canDisplay(item) {
                if(!this.search) {
                    return true;
                }
                let valid = false;
                _.forEach(item.child_items, (item) => {
                    if(this.canDisplay(item)) {
                        valid = true;
                    }
                });
                if(!valid){
                    let search = this.search.toLowerCase();
                    return (
                        item.type.toString().toLowerCase().includes(search)
                        || item.metal.toString().toLowerCase().includes(search)
                        || item.component_id.toString().toLowerCase().includes(search)
                    );
                }
                return valid;
            },
            compare(left, right) {
                if((left == null || right == null) && left != right) {
                    return true;
                }
                else if(left == null && left == right) {
                    return false;
                }
                if(left.length != right.length){
                    return true;
                }
                for(let i = 0; i < left.length; i++) {
                    if (left[i].id != right[i].id) {
                        return true;
                    }
                    if(this.compare(left[i].child_items, right[i].child_items)) {
                        return true;
                    }
                }
                return false;
            },
            whatMoved(newer, original, parent_id = null) {
                let ids = [];
                _.forEach(newer, (newItem) => {
                    if (original) {
                        for (let i = 0; i < original.length; i++) {
                            if (newItem.id == original[i].id) {
                                let childIds = this.whatMoved(newItem.child_items, original[i].child_items, newItem.id);
                                _.forEach(childIds, (item) => {
                                    ids.push(item);
                                });
                                return;
                            }
                        }
                    }
                    newItem.parent_id = parent_id;
                    ids.push({id:newItem.id, parent_id: parent_id});
                });
                return ids;
            },
            canBeChildOf(parent, child) {
                if(parent.container_type == 'list') {
                    //fix setting items back to original areas.
                    return parent.canMoveTo;
                } else if (parent.container_type == 'bag') {
                    console.log(_.findIndex(parent.container.inventory, (e) => {return e.id == child.container.id;}));
                    return _.findIndex(parent.container.inventory, (e) => {return e.id == child.container.id;}) != -1;
                }
                else if (parent.container_type == 'inventory') {
                    console.log(child.container, parent.container.children);
                    console.log(_.findIndex(parent.container.children, (e) => {return e.id == child.container.id;}));
                    return _.findIndex(parent.container.children, (e) => {return e.component_id == child.container.component_id;}) != -1;
                }
                return false;
            },
            checkMove(e, bag) {
                if(!this.loading && this.canBeChildOf(this.seekItemsCallback(e.to.id),e.draggedContext.element)){
                    return true;
                }
                //do not allow repositioning
                return false;
            },

            // signals parent to move bags from one section to another
            moveItem(section, item) {
                if(!this.loading) {
                    this.lastMoveAttemptSet('right-click');
                    this.startReason(item.id);
                    this.seekAndRemove(item);
                    this.statuses[section].items.push(item);
                    this.$forceUpdate();
                    this.$root.$emit('bv::hide::popover');
                }
            },
            rightClickHandler(e, row) {
                if(!this.loading) {
                    this.$root.$emit('bv::hide::popover');
                    let popover = 'click-control-' + row.id;
                    this.$root.$emit('bv::show::popover', popover);
                }
            },
            updateItems(newer, original, canUpdate) {
                let items = this.whatMoved(newer, original);
                if(this.status) {
                    if (canUpdate && items[0]) {
                        this.startReason(items[0].id);
                    }
                    _.forEach(items, (item) => {
                        item.status = this.status;
                        //remove ~, this is a counter, if null, it was a drag event.
                        if(!this.loading) {
                            item = _.cloneDeep(item); //prevents certain silly issues.
                            console.log('Read Attempt');
                            item.move_type = (this.lastMoveAttempt ? this.lastMoveAttempt : 'drag').replaceAll('~', '');
                            this.$http.post('/batch/updateItem/' + item.id, item);
                        }
                    });
                }
                else {
                    console.log('NO STATUS BUUUUUUUUUUUUG');
                }
                return items.length > 0;
            },
            doUpdate(canUpdate) {
                function customizer(value) {
                    if (_.isArray(value)) {
                        return value.reduce((acc, el) => {
                            acc.push(_.cloneDeepWith(el, customizer));
                            return acc;
                        }, []);
                    }
                }
                let updated = false;
                if (this.compare(this.cacheLocal, this.items)) {
                    updated = this.updateItems(this.items,this.cacheLocal, canUpdate);
                    this.localStatuses = _.cloneDeepWith(this.items, customizer);
                    this.cacheLocal = _.cloneDeepWith(this.localStatuses, customizer);
                }
                if(this.compare(this.localStatuses, this.cacheLocal)) {
                    updated = this.updateItems(this.localStatuses, this.cacheLocal, canUpdate);
                    this.replace(_.cloneDeepWith(this.localStatuses, customizer));
                    this.cacheLocal = _.cloneDeepWith(this.localStatuses, customizer);
                }
                if (updated && !this.loading && this.lastMoveAttempt) { //if null, no action needed. must be active item update, must not be loading page.
                    //decrement ~ count, if no ~, than set it to empty. ~ is used to count.
                    let copy = this.lastMoveAttempt;
                    console.log('Write Attempt ' + copy);
                    copy = copy.replace('~', '');
                    if (copy == this.lastMoveAttempt) {
                        copy = null;
                    }
                    console.log('POST WRITE -  ' + copy);
                    this.lastMoveAttemptSet(copy);
                }
            }
        },
        computed: {

        },
        watch: {
            items: {
                deep: true,
                handler() {
                    this.doUpdate(false);
                }
            },
            localStatuses: {
                deep: true,
                handler(value) {
                    this.doUpdate(true);
                }
            }
        }
    };
</script>

<style scoped>


    .batch-scroll {
        max-height: 400px;
        overflow: scroll;
        overflow-x: hidden;
    }

    .depth-0 {
        color: #000;
    }
    .depth-1 {
        padding-left: 15px;
        color: #13b0df;
    }
    .depth-2 {
        padding-left: 25px;
        color: #7ac1d9;
    }

</style>
